import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import config from "../../config";
import Main from "../../components/Main";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import ExportExcelConciliacao from "../../components/ExportExcelConciliacao";
import GenericYearMonthPicker from "../../components/GenericYearMonthPicker";
import ExportExcelButton from "../../components/ExportExcelButton";
import MensagemErro from "../../components/MensagemErro";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircleLoader from "react-spinners/CircleLoader";
import { TextSnippet } from "@mui/icons-material";
import axios from "axios";
import { buscarConciacaoContabil } from "../../services/api-conciliacao.service";

const TelaConsolidacaoContabil = () => {
  const [referencia, setReferencia] = useState(null);
  const [grupo, setGrupo] = useState("");
  const [dados, setDados] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const [loadingBuscar, setLoadingBuscar] = useState(false);
  const [capa, setCapa] = useState([]);
  const [grupoEconomico, setGrupoEconomico] = useState("");
  const [cnpjSelecionado, setCnpjSelecionado] = useState("");

  const handleBuscarConciliacao = async () => {
    if (!referencia || !grupo) return;

    setLoadingBuscar(true);

    const refFormatada = new Intl.DateTimeFormat("pt-BR", {
      year: "numeric",
      month: "2-digit",
    }).format(referencia);

    try {
      const data = await buscarConciacaoContabil(grupo, refFormatada);
      if (!data.sucesso) {
        setMsg(data.mensagem || "Erro ao buscar conciliação.");
        setOpenSnackbarErro(true);
        setDados([]);
        setCategorias([]);
        setCapa([]);
      } else {
        setDados(data.conciliacao || []);
        setCategorias(data.categorias || []);
        setCapa(data.capa || []);
      }
    } catch (err) {
      setMsg("Erro inesperado. Tente novamente.");
      setOpenSnackbarErro(true);
      console.error("Erro ao buscar conciliação:", err);
    } finally {
      setLoadingBuscar(false);
    }
  };

  const handleGrupoChange = (grupoSelecionado) => {
    const nomeCnpj = grupoSelecionado.nome_CNPJ || "";
    const partes = nomeCnpj.split("-");
    const cnpj = partes[0] || "";
    const grupoNome = partes.slice(1).join("-") || "";
    const cnpjConciliacao = grupoSelecionado.CNPJ || "";

    setGrupo(cnpjConciliacao); // aqui você quer usar apenas os números do CNPJ
    setCnpjSelecionado(cnpj);
    setGrupoEconomico(grupoNome.trim()); // nome do grupo econômico
  };

  const formatToBRL = (valor) => {
    return Number(valor).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const handleCloseSnackbarErro = (_, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbarErro(false);
  };

  const renderTabela = () => (
    <div className={styles.containerAccordion}>
      {loadingBuscar ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: "2rem" }}
        >
          <CircleLoader
            color="#18316e"
            loading={loadingBuscar}
            size={100}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        dados.map((item) => (
          <Accordion key={item.id} sx={{ marginBottom: "1rem" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>
                Código: {item.codigo} | Referência: {item.referencia} |
                Descrição: {item.descricao} | Saldo: {formatToBRL(item.saldo)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Conta</TableCell>
                      <TableCell>Referência</TableCell>
                      <TableCell>Saldo</TableCell>
                      <TableCell>Descrição</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {item.razoes.map((r) => (
                      <TableRow key={`${r.conta}-${r.referencia}`}>
                        <TableCell>{r.conta}</TableCell>
                        <TableCell>{r.referencia}</TableCell>
                        <TableCell>{formatToBRL(r.saldo)}</TableCell>
                        <TableCell>{r.descricao}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))
      )}
    </div>
  );

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={<TextSnippet fontSize="30px" />}
        headerTitle={
          <span style={{ fontSize: "1.7rem" }}>Conciliação Contábil</span>
        }
        AutoCompleteEmpresaCnpj
        handleEmpresaCnpjChange={handleGrupoChange}
        datePicker
        handleDate={setReferencia}
        labelDate="Referência"
        modalButtonLabel="Buscar"
        loading={loadingBuscar}
        handleOpenModal={handleBuscarConciliacao}
        customModalDisable={!grupo || !referencia}
      />

      <div className={styles.container}>
        {dados.length > 0 && renderTabela()}

        {dados.length > 0 && (
          <Box
            display="flex"
            justifyContent="flex-end"
            padding="0 2rem"
            marginTop="1rem"
          >
            <Box width="200px">
              {capa && capa.length > 0 && (
                <ExportExcelConciliacao
                  conciliacao={dados}
                  categorias={categorias}
                  referencia={referencia}
                  capa={capa}
                  grupoEconomico={grupoEconomico} 
                  cnpjSelecionado={cnpjSelecionado}
                />
              )}
            </Box>
          </Box>
        )}
      </div>

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default TelaConsolidacaoContabil;
